const validatePassword = (password: string) => {
    let score = 0;
    const validRules = [] as string[];

    if (password.length >= 6) {
        // Is 6 characters or longer.
        score += 33;
        validRules.push("validLength");
    }

    if (/^(?=.*[a-z])(?=.*[A-Z]).+$/.test(password)) {
        // Has uppercase and lowercase letter.
        score += 33;
        validRules.push("containsUppercase");
    }

    if (/\d/.test(password)) {
        // Contains at least one number.
        score += 34;
        validRules.push("containsNumber");
    }

    return {
        score,
        validRules,
    };
};

export default validatePassword;
